import React, { useState,useEffect } from 'react';
import ProjectsBar from '../components/ProjectsBar';
import ProjectCard from '../components/ProjectCard';
import projectsJson from '../resources/project.json';
import { AnimatePresence } from 'framer-motion';
function Projects() {
    const [shown, setShown] = useState('All');
    const [finalshown,setFinalshown] = useState('All')
    useEffect(() => {
        setFinalshown('dlakfja')
        setTimeout(() => {
            setFinalshown(shown)
        },1000)
    },[shown])
    return (
        <div id='projects' className='rounded-2xl my-10 bg-[#0F0F23] py-10 px-1'>
            <h1 className='text-center text-[30px] mb-5 text-white font-bold'>
                Open source projects and personal projects
            </h1>
            <ProjectsBar onShownTabChange={setShown} />
            <div className='py-12 max-md:justify-center flex gap-2 flex-wrap'>
            <AnimatePresence>
                {projectsJson.projects
                    .filter(project => finalshown === 'All' || project.category === finalshown)
                    .map((project, index) => (
                        <ProjectCard key={index} project={project} />
                    ))}
            </AnimatePresence>
            </div>
        </div>
    );
}

export default Projects;
